<div class="test-types-list row">
    <div *ngFor="let test of tests" class="col-lg-12">
        <label>
            <mat-checkbox (change)="handleSelectionChange($event, test.key)"
                          [checked]="isSelected(test.key)">
                {{test.label}}
            </mat-checkbox>
        </label>
    </div>
</div>